"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTipBoxSysSafety = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _dsIcons = require("@olxbr/ds-icons");
var _TipBox = _interopRequireDefault(require("../TipBox"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function TipBoxSysSafety(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    onPress = _ref.onPress,
    icon = _ref.icon,
    variant = _ref.variant;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
    tip: {
      icon: icon,
      text: text,
      cta: children,
      links: {
        web: onPress
      }
    },
    variant: variant
  });
}
TipBoxSysSafety.propTypes = {
  text: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  children: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string]),
  onPress: _propTypes.func.isRequired,
  icon: _propTypes.element.isRequired,
  variant: _propTypes.string.isRequired
};
var TipBoxSysSafetyAlert = function TipBoxSysSafetyAlert(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TipBoxSysSafety, _objectSpread(_objectSpread({}, props), {}, {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.AlertCircle, {}),
    variant: "default"
  }));
};
var TipBoxSysSafetyInfo = function TipBoxSysSafetyInfo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TipBoxSysSafety, _objectSpread(_objectSpread({}, props), {}, {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Info, {}),
    variant: "default"
  }));
};
var TipBoxSysSafetyWarningLight = function TipBoxSysSafetyWarningLight(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TipBoxSysSafety, _objectSpread(_objectSpread({}, props), {}, {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.AlertTriangle, {}),
    variant: "information"
  }));
};
var TipBoxSysSafetyWarningMedium = function TipBoxSysSafetyWarningMedium(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TipBoxSysSafety, _objectSpread(_objectSpread({}, props), {}, {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.AlertTriangle, {}),
    variant: "default"
  }));
};
var TipBoxByLevel = {
  'tip-info': TipBoxSysSafetyInfo,
  'tip-alert': TipBoxSysSafetyAlert,
  'tip-warning1': TipBoxSysSafetyWarningLight,
  'tip-warning2': TipBoxSysSafetyWarningMedium
};
var getTipBoxSysSafety = exports.getTipBoxSysSafety = function getTipBoxSysSafety(subType) {
  if (subType) {
    var prefix = Object.keys(TipBoxByLevel).find(function (prefix) {
      return subType.startsWith(prefix);
    });
    return prefix ? TipBoxByLevel[prefix] : null;
  }
  return null;
};